import React, { Component } from 'react';
import _set from 'lodash/set';
import _get from 'lodash/get';

import api from 'services';
import { getNormalErrors, showNotification } from 'helpers';

function transformRegion(region) {
  return {
    ...region,
    dwtGroup: region.dwtGroup.reduce((res, g) => {
      res[g.nameDwtGroup] = {
        percentToWW: g.percentToWW,
        ...g.prices.reduce((resPrices, price) => {
          resPrices[price.name] = {
            value: price.value,
            editedByUser: price.editedByUser
          }

          return resPrices;
        }, {})
      }

      return res;
    }, {})
  }
}

export default class Region extends Component {

  constructor(props) {
    super(props);

    this.state = {
      data: this.transformRegion(this.props.data),
      ts: this.props.ts,
      unfold: this.props.unfold,
      defaultUnfold: this.props.unfold,
      askingForSaveWWR: false,
      errors: {}
    }
  }

  static getDerivedStateFromProps(props, state) {
    if (
      _get(state, 'data._id', null) != _get(props, 'data._id', null)
      || state.ts != props.ts
    ) {
      let unfoldChange = {}

      if (_get(state, 'defaultUnfold', null) != _get(props, 'unfold', null)) {
        unfoldChange = {
          unfold: props.unfold,
          defaultUnfold: props.unfold
        }
      }

      return {
        data: transformRegion(props.data),
        ts: props.ts,
        ...unfoldChange
      }
    }

    return null;
  }

  transformRegion = transformRegion

  toggleUnfold = () => {
    this.setState({unfold: !this.state.unfold});
  }

  handleChange(changes = []) {

    function validateValue(value) {
      if (typeof value !== 'boolean') {
        let dots = 0;
        value = value
          .replace(/[^\d|\.|-]/, '')
          .replace(/\./g, function() { return dots++ > 0 ? '' : '.'; })
          .replace(/\-/g, function(match, str) { return str === 0 ? '-' : '' });
      }
      return value;
    }

    let data = JSON.parse(JSON.stringify(this.state.data));
    let errors = {};

    changes.forEach(v => {
      _set(data, v.key, validateValue(v.value));
      if (!v.noError) {
        errors[v.key] = v.value && typeof v.value !== 'boolean' && !isNaN(parseFloat(v.value)) ? '' : 'required'
      }
    })

    this.setState({
      data,
      errors: {
        ...this.state.errors,
        ...errors
      }
    })
  }

  toggleState = (key = 'askingForSaveWWR') => {
    this.setState({[key]: !this.state[key]})
  }

  askForSave = () => {
    this.isWWR() ? this.toggleState('askingForSaveWWR') : this.save();
  }

  save = async () => {
    let { data, errors } = this.state;
    let { tcRates } = this.props;

    if (
      Object.keys(errors).reduce((res, key) => {
        if (errors[key]) {
          res = true;
          return res;
        }
      }, false)
    ) {
      return showNotification('There is an error. Check out inputs', 'error');
    }

    let result = await api.timeCharters.updateTimeCharterRegion({
      type: this.props.type,
      _id: data._id,
      dwtGroup: Object.keys(data.dwtGroup).reduce((res, key) => {
        res.push({
          nameDwtGroup: key,
          percentToWW: data.dwtGroup[key].percentToWW,
          prices: tcRates.reduce((resPrice, rate) => {
            resPrice.push({
              name: rate,
              value: data.dwtGroup[key][rate].value,
              editedByUser: data.dwtGroup[key][rate].editedByUser
            })

            return resPrice;
          }, [])
        })
        return res;
      }, [])
    });

    if (result.status === 200) {
      showNotification('Region has been updated');
      return await this.props.getRegions()
    }

    showNotification(getNormalErrors(result).error, 'error')
  }

  remove = async () => {
    await this.props.removeRegion(this.state.data._id);
  }

  recalculate = async () => {
    await this.props.recalculateRegion(this.state.data);
  }

  isWWR = () => {
    return _get(this.state, 'data.region.name', '') === 'WWR'
  }
}



// WEBPACK FOOTER //
// ./app/components/TimeCharter/Base/region.js